/* ============================================================
   Honest state for a tool that is on the roadmap but not built.
   Better than a dead route, and better than pretending.
   ============================================================ */

import { html, raw } from '../shared/html.js';
import { icon } from '../shared/icons.js';
import { router } from '../shared/router.js';

export function PlannedPage(tool) {
  const page = document.createElement('div');
  page.className = 'container-narrow page animate-fade-in';

  page.innerHTML = html`
    <div class="empty-state">
      <div
        class="tool-icon"
        style="margin: 0 auto var(--ca-space-4); width: 52px; height: 52px;
               background: color-mix(in srgb, ${tool.accent} 12%, transparent); color: ${tool.accent};"
      >
        ${raw(icon(tool.icon, 26))}
      </div>
      <h1>${tool.title}</h1>
      <p>${tool.summary}</p>
      <span class="chip" style="margin-bottom: var(--ca-space-5);">
        Scheduled for ${tool.phase || 'a later phase'}
      </span>
      <div class="stack" style="max-width: 280px; margin-inline: auto;">
        <button class="btn btn-secondary" id="back-home" type="button">Back to the dashboard</button>
      </div>
    </div>
  `;

  page.querySelector('#back-home').addEventListener('click', () => router.navigate('/'));
  return page;
}

export function NotFoundPage(path) {
  const page = document.createElement('div');
  page.className = 'container-narrow page animate-fade-in';
  page.innerHTML = html`
    <div class="empty-state">
      <h1>That screen doesn’t exist</h1>
      <p>Nothing is routed at <code>${path}</code>. It may have moved, or the link may be stale.</p>
      <a class="btn btn-secondary" href="/">Back to the dashboard</a>
    </div>
  `;
  return page;
}
